import { ClearableInput } from "@rio-cloud/rio-uikit";
import { InputHTMLAttributes } from "react";

interface IAssetSearchProps {
  search: string;
  setSearch: (value: string) => void
}

const AssetSearch = ({ search, setSearch }: IAssetSearchProps) => {
  return (
    <div className="padding-15">
      <form action="">
        <div className='form-group margin-0'>
            <div className='input-group'>
                <span className='input-group-addon'>
                    <span className='rioglyph rioglyph-search' aria-hidden='true' />
                </span>
                <ClearableInput
                  id='search'
                  value={search}
                  placeholder="Faça uma busca"
                  onChange={e => setSearch(e)}
                />
            </div>
        </div>
      </form>
    </div>
  )
}

export default AssetSearch
